/* eslint-disable max-lines */
import { getStore } from '@/utils/dva'
import qs from 'qs'
/*
 * 现有的7个appCode
 * */
export const LOCAL_WIDTH_FINDCOOPERATION_CHANNEL = 'light.scm121.com' // 带寻合作的分销版
export const LOCAL_DY_GOODS_APP_CODE = 'dygoods.sursung.com'
export const LOCAL_DY_PRINT_APP_CODE = 'dyprint.sursung.com'
export const LOCAL_KS_GOODS_APP_CODE = 'ksgoods.sursung.com'
export const LOCAL_KS_PRINT_APP_CODE = 'ksprint.sursung.com'
export const LOCAL_JHT_LIVE_CODE = 'live.juhuotong.com'
export const LOCAL_JHT_FACTORY_CODE = 'factory.juhuotong.com'
export const LOCAL_JHT_PC_CODE = 'pc.juhuotong.com'
// 用于判断是否是JHT
export const JHT_CODE_LIST = [LOCAL_JHT_LIVE_CODE, LOCAL_JHT_FACTORY_CODE, LOCAL_JHT_PC_CODE]

export const getIsJHT = appCodeParam => {
    const appCodeV1 = appCodeParam || appCode
    return JHT_CODE_LIST.indexOf(appCodeV1) > -1
}

/*
 * 货通域名:
 *
 * live.juhuotong.com
 * liveaccount.juhuotong.com
 *
 * factory.juhuotong.com
 * factoryaccount.juhuotong.com
 *
 * pc.juhuotong.com
 * pcaccount.juhuotong.com
 * */

export const LOCAL_TEST_APP_CODE_LIST = [
    {
        label: '主版',
        value: 'main'
    },
    {
        label: '分销极速版',
        value: LOCAL_WIDTH_FINDCOOPERATION_CHANNEL
    },
    {
        label: '抖音商品版',
        value: LOCAL_DY_GOODS_APP_CODE
    },
    {
        label: '抖音打单版',
        value: LOCAL_DY_PRINT_APP_CODE
    },
    {
        label: '快手商品版',
        value: LOCAL_KS_GOODS_APP_CODE
    },
    {
        label: '快手打单版',
        value: LOCAL_KS_PRINT_APP_CODE
    },
    {
        label: '聚货通档口直播版',
        value: LOCAL_JHT_LIVE_CODE
    },
    {
        label: '聚货通工厂版',
        value: LOCAL_JHT_FACTORY_CODE
    },
    {
        label: '聚货通pc版',
        value: LOCAL_JHT_PC_CODE
    }
]

/*
 * 持久化存储，仅用作调试
 * */
export const _cacheAppCode = localStorage.getItem('__tmp_app_code') || LOCAL_TEST_APP_CODE_LIST[0].value
export const _cacheIsEnable = _cacheAppCode !== LOCAL_TEST_APP_CODE_LIST[0].value

const isAccountOrGylOrSc =
    PROJECT_CONFIG.terminalName === 'ACCOUNT' ||
    PROJECT_CONFIG.terminalName === 'CHANNEL' ||
    PROJECT_CONFIG.terminalName === 'SUPPLIER'

const isDevOrTestOrUat =
    PROJECT_CONFIG.mode === 'dev' || PROJECT_CONFIG.mode === 'test' || PROJECT_CONFIG.mode === 'uat'
// 预发也先打开
const isLocalOrScm121 =
    PROJECT_CONFIG.mode === 'dev' ||
    (!!(document.domain && /\.scm121\.com$/.test(document.domain)) && !/light\./.test(document?.domain)) // 1.dev环境 2.域名是scm121并且不包含light 因为light.scm121也是独立域名

/*
 * 是否能够在页面上切换appCode
 * */
export const canSwitchAppCode = isDevOrTestOrUat && isAccountOrGylOrSc && isLocalOrScm121

// 匹配appCode正则
// temp为给后端增加的临时测试环境变量
const APP_CODE_REG_EXP = /^(temp|test|uat|pre)?(.*?)(account|gyl|sc)?$/

/*
 * 应用类型
 */
export const PRINT_APP_TYPE = 'print' // 打单版
export const GOODS_APP_TYPE = 'goods' // 商品版

export const code = (() => {
    const dArr = document.domain.split('.')
    const arr = dArr[0].match(/^(temp|test|uat|pre)?(.*?)(account|gyl|sc)?$/)

    if (arr[2]) {
        return [arr[2]].concat(dArr.slice(1)).join('.')
    }

    return ''
})()

// 判断当前域名是否为应用市场
export const isSingleAppDomain = (() => {
    if (canSwitchAppCode && _cacheIsEnable) {
        return true
    }

    return isAccountOrGylOrSc && LOCAL_TEST_APP_CODE_LIST.some(v => v.value === code)
})()

/*
 * 根据域名获取appCode
 * 域名规格：account: test{appCode}account、uat{appCode}account、pre{appCode}account、{appCode}account
 *         gyl: test{appCode}、uat{appCode}、pre{appCode}、{appCode}
 *         sc: test{appCode}、uat{appCode}、pre{appCode}、{appCode}
 * */
export const appCode = (() => {
    if (!isSingleAppDomain) {
        return ''
    }

    if (canSwitchAppCode && _cacheAppCode) {
        return _cacheAppCode
    }

    return code
})()

// 清除域名中环境前缀
const clearDonmainEnvPrefix = domain => {
    return domain.replace(/^(temp|test|uat|pre)/, '')
}

// 所有版本的appCode
export const fullAppCode = (() => {
    const urlObj = new URL(window.location.href)
    const withoutEnvPreifixHost = clearDonmainEnvPrefix(urlObj.host)

    // 寻合作
    if (withoutEnvPreifixHost.includes('ttdahuo.com')) {
        return withoutEnvPreifixHost.replace('ttdahuo', 'scm121')
    }

    // 独立站
    if (PROJECT_CONFIG.terminalNameSecond === PROJECT_CONFIG.dlzTerminalName) {
        return 'pinpai.scm121.com'
    }

    // 本地
    if (PROJECT_CONFIG.mode === 'dev') {
        const map = {
            [PROJECT_CONFIG.supplierTerminalName]: 'sc.scm121.com',
            [PROJECT_CONFIG.channelTerminalName]: 'gyl.scm121.com'
        }

        return map[PROJECT_CONFIG.terminalName] || 'sc.scm121.com'
    }

    // 打单和塔内特殊处理
    if (
        window.PROJECT_CONFIG.localTerminalName === 'PRINT' ||
        window.PROJECT_CONFIG.terminalName === 'TOWER' ||
        window.PROJECT_CONFIG.terminalName === 'DAREN'
    ) {
        const urlQuery = qs.parse(window.location.search, {
            ignoreQueryPrefix: true
        })
        if (urlQuery.appcode) {
            return urlQuery.appcode
        }
        // 目前所有的获取erp环境的方法都是异步的，不能在自执行函数中使用判断erp环境的方法
        // 不在供应链，就是单开，统一用供应侧
        if (!urlQuery.__POWERED_BY_GYL_FRAME__) {
            return 'sc.scm121.com'
        }
    }
    // 市场版
    if (isSingleAppDomain) {
        return appCode
    }

    // 分销版
    return clearDonmainEnvPrefix(document.domain)
})()

// 是否是打单版
export const isPrint = appCode && appCode.includes('print')

// 是否是商品版
export const isGoods = appCode && appCode.includes('goods')

// 是否是聚货通
export const isJht = appCode && [LOCAL_JHT_LIVE_CODE, LOCAL_JHT_FACTORY_CODE, LOCAL_JHT_PC_CODE].includes(appCode)

// 是否是聚货通直播版
export const isJhtLive = appCode && [LOCAL_JHT_LIVE_CODE].includes(appCode)

// 是否是聚货通工厂版
export const isJhtFactory = appCode && appCode === LOCAL_JHT_FACTORY_CODE

// 是否是聚货通PC版
export const isJhtPC = appCode && appCode === LOCAL_JHT_PC_CODE

// 是否是分销极速版
export const isLightChannel = appCode && appCode === LOCAL_WIDTH_FINDCOOPERATION_CHANNEL
export const isSpeedChannel = fullAppCode === LOCAL_WIDTH_FINDCOOPERATION_CHANNEL

// 纵横版应用，通过域名判断，注意和市场版不一样，可以看作同级
// 注意只是表示应用是纵横版，用户合同不一定是纵横版
// testzh.scm121.com
// uatzh.scm121.com
// prezh.scm121.com
// zh.scm121.com

export const isZongHengApp = (() => {
    const dArr = document.domain.split('.')
    const arr = dArr[0].match(APP_CODE_REG_EXP)
    const curCode = arr[2] || ''

    return curCode === 'zh'
})()

// 是否是寻合作
export const isTtDaHuoApp = document.domain.includes('ttdahuo.com')

// 打单版本
export const shouldShowPlatformPrint = () => {
    return [LOCAL_DY_PRINT_APP_CODE, LOCAL_KS_PRINT_APP_CODE].includes(appCode)
}

// 商品版本
export const shouldShowPlatformGoods = () => {
    return [LOCAL_DY_GOODS_APP_CODE, LOCAL_KS_GOODS_APP_CODE].includes(appCode)
}

/*
 * 获取应用首页
 * */
export const getHomePage = () => {
    const store = getStore()
    const state = (store && store.getState()) || {}

    const menu = state?.menu?.userMenus || []
    const blackList = state?.menu?.blackMenuList || []

    // 有效菜单
    const validMenus = menu.filter(
        v =>
            typeof v.erpMenuUrl === 'string' &&
            v.erpMenuUrl.trim() &&
            !blackList.includes(v.erpMenuUrl.trim() && v.hasRole)
    )

    return validMenus[0]
}

// 转化应用配置数据至dva
export const getAppConfig = () => {
    const appConfig = window.__SINGLE_APP_SETTINGS?.appConfig || {}
    const appType = window.__SINGLE_APP_SETTINGS?.appType || {}

    try {
        const res = JSON.parse(appConfig)

        return res
            ? {
                  ...res,
                  appType
              }
            : {}
    } catch (e) {
        console.error('catchError', e)
        return {}
    }
}

/*
 * 获取端域名前缀
 * */
export const getTerminalPrefix = terminalName => {
    const dArr = document.domain.split('.')
    const arr = dArr[0].match(APP_CODE_REG_EXP)

    const prefix = arr[1] || ''
    const code = arr[2] || ''

    switch (terminalName) {
        case PROJECT_CONFIG.supplierTerminalName:
            return `${prefix}${code}`
        case PROJECT_CONFIG.channelTerminalName:
            return `${prefix}${code}`
        case PROJECT_CONFIG.accountTerminalName:
            return `${prefix}${code}account`
        default:
            return ''
    }
}

// 获取应用配置
const getAppSettings = () => {
    const store = getStore()?.getState() || {}
    return store.settings || {}
}

/*
 * 获取资源位appCode
 * */
export const getResourceAppCode = () => {
    if (isSingleAppDomain) {
        const { resourceAppCode } = getAppSettings()

        return resourceAppCode
    }

    return PROJECT_CONFIG[`SCM_${PROJECT_CONFIG.terminalName}_APPCODE`]
}

/*
 * 获取帮助中心地址
 * */
export const getHelpCenterUrl = ({ appVersion, pathname }) => {
    const supplierVersionUrl =
        appVersion === 'shengtaiban' || appVersion === 'zonghengbiaozhunban' || isZongHengApp
            ? 'https://help.scm121.com/v/latitude'
            : 'https://help.scm121.com/v/supplier'
    const channelVersionUrl =
        appVersion === 'shengtaiban' || appVersion === 'zonghengbiaozhunban' || isZongHengApp
            ? 'https://help.scm121.com/v/latitude'
            : 'https://help.scm121.com/v/channel'
    const TERMINAL_MAP = {
        [PROJECT_CONFIG.supplierTerminalName]: supplierVersionUrl,
        [PROJECT_CONFIG.channelTerminalName]: channelVersionUrl
    }

    const url = TERMINAL_MAP[PROJECT_CONFIG.terminalName] || supplierVersionUrl
    if (isSingleAppDomain) {
        const { helpCenterUrl } = getAppSettings()

        const APP_CODEE_MAP = {
            [LOCAL_DY_GOODS_APP_CODE]: () => 'https://help.scm121.com/v/d_y_shelves/c/3D4DBF0F5CA04D87A1C07632606C1B89',
            [LOCAL_DY_PRINT_APP_CODE]: () => 'https://help.scm121.com/v/d_y_print/c/796D9ED5DF5746C69D297558314018FE',
            [LOCAL_KS_GOODS_APP_CODE]: () => 'https://help.scm121.com/v/k_s_shelves/c/01A49CF11D5F4AEFA9C265B9A10175A2',
            [LOCAL_KS_PRINT_APP_CODE]: () => 'https://help.scm121.com/v/k_s_print/c/8C66C6A965F248F49C3B57EFB778F57D',

            [LOCAL_JHT_LIVE_CODE]: () => {
                if (pathname.indexOf('/jht/') > -1) {
                    return 'https://jushuitan.yuque.com/books/share/1aa1a5e0-5a4e-4e5a-af5d-b26a525ef5a7?#'
                }
                return url
            },
            [LOCAL_JHT_PC_CODE]: () => {
                if (pathname.indexOf('/jht_pc/') > -1) {
                    return 'https://jushuitan.yuque.com/books/share/854d6744-4bae-43e9-8bbd-46cc742dca15?#'
                }
                return url
            }
        }

        return helpCenterUrl || APP_CODEE_MAP[appCode]?.() || TERMINAL_MAP[PROJECT_CONFIG.terminalName]
    }

    return url
}

/*
 * 获取技巧按钮地址
 * */
export const getSkillUrl = ({ pathname }) => {
    const supplierSkillUrl = 'https://help.scm121.com/v/supplier/c/D18D38AE11C240C1A0298EA62B9BB78D'
    const channelSkillUrl = 'https://help.scm121.com/v/channel/c/AACAAB1D08D94B19A7B2C446AD55B2F6'

    const TERMINAL_MAP = {
        [PROJECT_CONFIG.supplierTerminalName]: supplierSkillUrl,
        [PROJECT_CONFIG.channelTerminalName]: channelSkillUrl
    }

    const url = TERMINAL_MAP[PROJECT_CONFIG.terminalName] || supplierSkillUrl

    if (isSingleAppDomain) {
        const APP_CODEE_MAP = {
            [LOCAL_JHT_LIVE_CODE]: () => {
                if (pathname.indexOf('/jht/') > -1) {
                    return 'https://jushuitan.yuque.com/books/share/54246ea2-4288-44ae-919e-75ca2cb9f0c7?#'
                }
                return url
            },
            [LOCAL_JHT_PC_CODE]: () => {
                if (pathname.indexOf('/jht_pc/') > -1) {
                    return 'https://jushuitan.yuque.com/books/share/bf4161eb-253d-46db-9db3-693f6ea05abd?#'
                }
                return url
            }
        }

        return APP_CODEE_MAP[appCode]?.() || TERMINAL_MAP[PROJECT_CONFIG.terminalName]
    }

    return url
}

export const getFromBuInRegister = () => {
    // 默认是jst-gyl-pc，
    // 聚货通pc：jst-jht-web.pc
    // 聚货通live：jst-jht-web.live
    //  工厂版：jst-jht-web.factory
    // https://devops.aliyun.com/projex/project/44d4f6c7abd42f6e6d0ad44638/req/317677bd9c95b8964c05958343

    if (isJhtLive) {
        return 'jst-jht-web.live'
    }
    if (isJhtFactory) {
        return 'jst-jht-web.factory'
    }
    if (isJhtPC) {
        return 'jst-jht-web.pc'
    }

    return 'jst-gyl-pc'
}

export const apiHeadersObject = {
    appCode: fullAppCode
}
